import React, { createContext, useContext, useEffect, useState } from 'react';

const KEY = 'snt:city';
const DEFAULT_CITY = 'Bengaluru';

const LocationContext = createContext(null);

export function LocationProvider({ children }) {
  const [city, setCityState] = useState(() => {
    if (typeof window === 'undefined') return DEFAULT_CITY;
    return localStorage.getItem(KEY) || DEFAULT_CITY;
  });

  const setCity = (newCity) => {
    setCityState(newCity);
    if (typeof window !== 'undefined') localStorage.setItem(KEY, newCity);
  };

  // Cross-tab sync
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const handler = (e) => {
      if (e.key === KEY && e.newValue) setCityState(e.newValue);
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  return (
    <LocationContext.Provider value={{ city, setCity }}>
      {children}
    </LocationContext.Provider>
  );
}

export function useLocation() {
  const ctx = useContext(LocationContext);
  if (!ctx) throw new Error('useLocation must be used within LocationProvider');
  return ctx;
}

/** r7.8 — the optional read, like useTenantOptional() / useThemeOptional(): null outside the provider. */
export function useLocationOptional() {
  return useContext(LocationContext);
}

export const POPULAR_CITIES = [
  'Bengaluru', 'Mumbai', 'Delhi NCR', 'Hyderabad', 'Chennai',
  'Kolkata', 'Pune', 'Ahmedabad', 'Kochi', 'Goa',
];
